<template>
    <div class="home topbar-container">
        <div class="line"></div>
        <div class="list" v-show="isApp">
            <van-button @click="updatePasswordClick" class="btn b btn-text">
                <div class="bh bstart">
                    <div class="fz_32 b1 tl">{{passwordText}}</div>
                    <div class="bg-contain ico-next"></div>
                </div>
            </van-button>
            <van-button class="btn btn-text b" @click="onClearClick">
                <div class="bh bstart">
                    <span class="fz_34">清理缓存</span>
                </div>
            </van-button>
            <van-button class="btn btn-text">
                <div class="fz_32 tl">版本号：{{version}}</div>
            </van-button>
        </div>
        <van-button class="btn btn-submit-big" @click="onLoginOutClick">退出系统</van-button>
    </div>
</template>
<script>
import { loginOut, checkPassword } from "@/api/user";
import { setToken } from "@/utils/user";
import { appLoginout, appClearWebViewCache } from "@/utils/native";
import { user } from "@/mixin/user";
export default {
    mixins: [user],
    name: "UserSite",
    data() {
        return {
            isNewPassword: false
        };
    },
    computed: {
        version() {
            return this.$store.state.version;
        },
        isApp() {
            return this.$store.state.isApp;
        },
        passwordText() {
            return this.isNewPassword ? "设置密码" : "修改密码";
        }
    },
    methods: {
        onClearClick() {
            appClearWebViewCache();
        },
        updatePasswordClick() {
            this.go("UserPassWord", {
                isNewPassword: this.isNewPassword
            });
        },
        userLoginend() {
            if (this.isApp) {
                checkPassword().then(res => {
                    this.isNewPassword = res.data.data;
                });
            }
        },
        onLoginOutClick: function() {
            const me = this,
                state = me.$store.state;
            if (state.isApp) {
                appLoginout();
            } else {
                loginOut({
                    telephone: state.userInfo.telephone
                }).then(res => {
                    // 退出登录一系列操作
                    setToken("", "");
                    // 进入商城首页
                    me.replaceGo("ShopHome");
                });
            }
        }
    }
};
</script>
<style scoped lang="scss">
.home {
    background-color: #f1f2f3;
    .version {
        background-color: #ffffff;
        padding: 40px;
    }
    .btn-submit-big {
        position: absolute;
        margin-left: 145px;
        width: calc(100% -290px);
        bottom: 269px;
    }
}
.list {
    background-color: #fff;
    padding: 0 40px;
    .van-button {
        width: 100%;
    }
    .btn {
        margin-top: 0;
        padding: 40px 0;
        color: #333333;
        .btn-ico-el {
            width: 38px;
            height: 38px;
            margin-right: 30px;
        }
    }
    .b {
        border-bottom: solid 1px #ededed;
    }
}
.ico-next {
    width: 21px;
    height: 39px;
}
</style>
